export const GET_CATEGORIES= 'GET_CATEGORIES'
export const GET_CATEGORIES_SUCCESS= 'GET_CATEGORIES_SUCCESS'
export const GET_CATEGORIES_ERROR='GET_CATEGORIES_ERROR'

export const GetCategories= (data) => ({
    type: GET_CATEGORIES,
    payload: data
});
